import axios from 'axios';
import { store } from './store';
import { SHOW_ERROR } from './actions/actionTypes';

let isGetActiveSessionRequest = false;
let requestQueue = [];

const callRequestsFromQueue = _ => {
    requestQueue.forEach(sub => sub());
};
const addRequestToQueue = sub => {
    requestQueue.push(sub);
};
const clearQueue = () => {
    requestQueue = [];
};

const refreshToken = async () => await axios.get(process.env.REACT_APP_GATEWAY_URL_REFRESH_TOKEN);

axios.interceptors.request.use(async config => {
    config = {
        ...config,
        withCredentials: true,
        headers: {
            'Access-Control-Allow-Origin': process.env.REACT_APP_URL,
            'Access-Control-Allow-Methods': 'GET,HEAD,OPTIONS,POST,PUT',
            'Content-Type': 'application/json',
        },
    };
    return config;
});

axios.interceptors.response.use(null, error => {
    const { response = {}, config: sourceConfig } = error;

    if (response.status >= 500) {
        const {
            data: { server, message },
        } = error.response;
        store.dispatch({
            type: SHOW_ERROR,
            payload: `Ops! Servidor: ${server} Mensagem: ${message}`,
        });
        return Promise.reject(error);
    }
    if (response.status === 400) {
        window.location.href = process.env.REACT_APP_GATEWAY_URL_LOGOUT;
        return Promise.reject(error);
    }

    if (response.status === 401) {
        if (!isGetActiveSessionRequest) {
            isGetActiveSessionRequest = true;
            refreshToken()
                .then(_ => {
                    isGetActiveSessionRequest = false;
                    callRequestsFromQueue();
                    clearQueue();
                })
                .catch(e => {
                    isGetActiveSessionRequest = false;
                    clearQueue();
                });
        }

        const retryRequest = new Promise(resolve => addRequestToQueue(_ => resolve(axios(sourceConfig))));
        return retryRequest;
    } else {
        return Promise.reject(error);
    }
});

export default axios;
